// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-overlay-stage{display:block;visibility:visible !important}.video-overlay-stage__player .vjs-tech:focus{outline:none}.video-overlay-stage__player .vjs-control:focus{outline:none}.video-overlay-stage__player .vjs-resolution-button-label{display:none}", ""]);
// Exports
module.exports = exports;
